<h2 mat-dialog-title>შაბლონის {{ data.editing ? 'რედაქტირება' : 'დამატება' }}</h2>

<form [formGroup]="form" (ngSubmit)="submit()">
    <mat-dialog-content>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>სახელწოდება</mat-label>
            <input matInput formControlName="name" />
            @if (form.controls.name.touched && form.controls.name.invalid) {
                <mat-error>სავალდებულო ველი</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>კოდი</mat-label>
            <input matInput formControlName="code" />
            @if (form.controls.code.touched && form.controls.code.invalid) {
                <mat-error>სავალდებულო ველი</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>აღწერა</mat-label>
            <input matInput formControlName="description" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>საბოლოო გამოცდაზე დასაშვები მინიმალური ქულა</mat-label>
            <input matInput type="number" formControlName="finalExamBarrier" />
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="close()">გაუქმება</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">დადასტურება</button>
    </mat-dialog-actions>
</form>
